// extracted by mini-css-extract-plugin
export default {"line":"Line_line__jP5En","lineMargins":"Line_lineMargins__VdUYj"};